import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, useNavigate, useParams } from "react-router";

import { AppContext } from '../../context.js';
import Loading from "../components/loading.js";
import axios from "axios";

function Create() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [referral, setReferral] = useState(null);
  const [settings, setSettings] = useState(null);
  const [template, setTemplate] = useState(null);

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.get('/api/admin/settings', {
      }),
    ]).then(axios.spread((settings) => {
      setSettings(settings.data);
      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  if (loading) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <Loading />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xs-12 col-lg-offset-1 col-lg-10">
            <div className="d-flex justify-content-between align-items-center">

              {/* Referrals */}
              <div className="w-25">
                <div className="typo-strong-400">Referrals</div>
              </div>

              {/* Patients */}
              <div className="w-25">
                <div className="typo-strong-400">Patients</div>
                
              </div>

              {/* Projects */}
              <div className="w-25">
                <div className="typo-strong-400">Projects</div>
                
              </div>

              {/* Activities */}
              <div className="w-25">
                <div className="typo-strong-400">Activities</div>
                
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Create;
